module.exports = __webpack_public_path__ + "img/104.260e246a.png";